module.exports = __webpack_public_path__ + "img/wind-loads.bb2aaf9d.jpg";